import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { RecipientsViewModel } from "../../../../domain/RecipientsViewModel";
import { closeRecipients } from "../../../../redux/actions";

const useStyles = makeStyles((theme) => ({
  actions: {
    padding: 15,
  },
}));

type CloseDialogDialogProps = {
  onClose: () => void;
  recipients: RecipientsViewModel;
};

export const CloseDialog: React.FC<CloseDialogDialogProps> = ({
  onClose,
  recipients,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const orgsToClose = recipients.orgs.filter((org) => org.isSelected);

  const handleConfirm = () => {
    dispatch(
      closeRecipients(
        recipients.id,
        orgsToClose.map((org) => org.id)
      )
    );
    onClose();
  };

  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Close confirmation</DialogTitle>
      <DialogContent>
        Are you sure you want to close the request for the following recipients:{" "}
        {orgsToClose.map((org) => org.name).join(", ")}?
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          component="button"
          color="primary"
          onClick={onClose}
          data-test="close-cancel-button"
        >
          Cancel
        </Button>
        <Button
          component="button"
          color="primary"
          onClick={handleConfirm}
          data-test="close-confirm-button"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
